import * as React from "react";

const RenderAnswerBox = (props: any) => {
    const onChange = (e: any) => {
        props.onChange(e.currentTarget.value);
    };
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-xs-12 col-no-gutter">
                    <div className="form-row row">
                        <div className="form-label col-xs-12 col-no-gutter">
                            <label htmlFor={`number-${props.id}`}>{props.Title}</label>
                        </div>
                        <div className="form-input col-xs-12 col-sm-3 col-no-gutter">
                            <input type="number" id={`number-${props.id}`} name="number" className="inputbox" defaultValue={props.answer} min="0" onBlur={onChange} placeholder="" />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default RenderAnswerBox;
